import { FormlyFieldConfig } from '@ngx-formly/core';

export class ScheduleReminderFormFields {
  fields: FormlyFieldConfig[] = [
    {
      key: 'date',
      type: 'datepicker',
      templateOptions: {
        label: 'Date',
        placeholder: 'Choose a date',
        required: true,
        attributes: {
          'data-cy': 'reminder-date-input'
        },
      },
    },
    {
      className: 'time-field time-padding',
      key: 'hour',
      type: 'text',
      templateOptions: {
        label: 'Hour',
        required: true,
        min: 1,
        max: 12,
        attributes: {
          'data-cy': 'reminder-hour-input'
        },
      },
    },
    {
      className: 'time-field time-padding',
      key: 'minutes',
      type: 'text',
      templateOptions: {
        label: 'Minutes',
        required: true,
        min: 0,
        max: 59,
        minLength: 2,
        attributes: {
          'data-cy': 'reminder-minutes-input',
          'name': 'minutes'
        },
      },
    },
    {
      className: 'time-field',
      key: 'meridiem',
      type: 'select',
      templateOptions: {
        label: 'AM/PM',
        required: true,
        options: [
          { value: 'am', label: 'AM' },
          { value: 'pm', label: 'PM' },
        ],
        attributes: {
          'data-cy': 'reminder-meridiem-select'
        }
      }
    },
    {
      key: 'action',
      type: 'select',
      templateOptions: {
        label: 'Reminder Type',
        placeholder: 'Choose a type',
        required: true,
        options: [
          { value: 'call', label: 'Call Back' },
          { value: 'message', label: 'Message' },
          { value: 'todo', label: 'To Do' },
          { value: 'other', label: 'Other' },
        ],
        attributes: {
          'data-cy': 'reminder-type-select'
        }
      }
    },
    {
      key: 'reason',
      type: 'textarea',
      templateOptions: {
        required: false,
        label: 'Reason',
        placeholder: 'Details to remember',
        rows: 5,
        attributes: {
          'data-cy': 'reminder-reason-textarea'
        }
      }
    }
  ];

  constructor() {}

  get getFields() {
    return this.fields;
  }
}
